import React from 'react'
import { makeStyles } from '@material-ui/core/styles'
import CircularProgress from '@material-ui/core/CircularProgress'
import Button from '@material-ui/core/Button'
import PropTypes from 'prop-types'

const useStyles = makeStyles(theme => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
    height: '100vh',
    margin: '32px',
    justifyContent: 'center',
    alignItems: 'center',
  },
  button: {
    marginTop: theme.spacing(2),
  },
}))

const LoadingPage = ({ text, action }) => {
  const classes = useStyles()
  return (
    <div className={classes.container}>
      {!action && <CircularProgress color='primary' />}
      <p>{text}</p>
      {action && (
        <Button
          variant='contained'
          color='primary'
          onClick={action.onClick}
          className={classes.button}
        >
          {action.text}
        </Button>
      )}
    </div>
  )
}

LoadingPage.propTypes = {
  text: PropTypes.string.isRequired,
  action: PropTypes.shape({
    text: PropTypes.string.isRequired,
    onClick: PropTypes.func.isRequired,
  }),
}

export default LoadingPage
